import { configureStore } from "@reduxjs/toolkit";
import thunk from "redux-thunk";
import rootReducer from "./rootReducer";
import * as Sentry from "@sentry/react";

const initialState = {};

const sentryReduxEnhancer = Sentry.createReduxEnhancer({
    // Optionally pass options listed below
});

const store = configureStore({
    reducer: rootReducer,
    middleware: [thunk],
    enhancers: [sentryReduxEnhancer],
    preloadedState: initialState,
});

export default store;
